import { useState, useEffect }  from 'react';
import ProductSelection         from './product-selection'

const Message = props => {
    const p                 = props;
    const [ s, setState ]   = useState({
        isTyping:    p.type === 'response' && !p.skipAnimation,
        displayText: p.type !== 'response' || p.skipAnimation ? p.message : ''
    });

    useEffect(() => {
        let interval;
        if (p.type === 'response' && !p.skipAnimation) {
            const charCount = p.message.length;
            let currentChar = 0;
            interval = setInterval(() => {
                currentChar++;
                const text = p.message.substring(0, currentChar);

                if (currentChar >= charCount) {
                    clearInterval(interval);
                    setState({ isTyping: false, displayText: p.message });
                } else {
                    setState(prev => ({ ...prev, displayText: text }));
                }

                p.scrollToBottom();
            }, 25);
        }

        p.scrollToBottom();

        return(() => {
            clearInterval(interval);
        })
    }, []) // eslint-disable-line

    return (
        p.type === 'product'
            ?   <ProductSelection
                    selectProduct       = { id => p.selectProduct(id) }
                    sourceProjectId     = { p.sourceProjectId }
                    isProductSelected   = { p.isProductSelected }
                    t                   = { p.t }
                />
            :   <div className={ `${p.type}${p.type === 'response' && !s.isTyping ? ' complete' : ' typing'}` }>
                    {
                        p.type === 'response'
                            ?   <div className={ `status${!s.isTyping ? ' complete' : ' typing'}` } />
                            :   null
                    }
                    <div className="post">{ s.displayText }</div>
                </div>

    )
}

export default Message;